var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpring({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 1.976,
    d: "M36.285 5.698c2.273-1.312 4.669-1.84 6.967-1.732 2.48.117 4.845.976 6.813 2.383 1.954 1.397 3.519 3.335 4.415 5.63.78 2 1.05 4.27.636 6.686l-.08.428-.585 2.869 2.203-1.928a12.77 12.77 0 0110.486-3.033c3.612.58 6.958 2.7 8.948 6.145 1.99 3.447 2.152 7.405.847 10.822a12.749 12.749 0 01-7.516 7.43l-.356.127-2.774.943 2.778.93c2.495.834 4.464 2.266 5.886 4.042 1.54 1.924 2.437 4.249 2.67 6.64a12.787 12.787 0 01-1.342 7.093c-1.055 2.045-2.711 3.855-4.984 5.167a12.583 12.583 0 01-7.613 1.633 12.806 12.806 0 01-6.89-2.91l-.292-.252-2.222-1.974.598 2.912c.678 3.305.147 6.24-1.173 8.631-1.487 2.694-3.961 4.694-6.782 5.775-2.825 1.081-6.003 1.243-8.901.229-2.574-.9-4.918-2.733-6.6-5.647-1.537-2.662-1.936-5.644-1.438-8.461l.066-.351.586-2.872-2.205 1.93c-3.052 2.673-6.9 3.62-10.486 3.045-3.613-.578-6.96-2.698-8.95-6.146-1.99-3.446-2.152-7.404-.847-10.823a12.774 12.774 0 017.52-7.44l.356-.127 2.778-.947-2.786-.926c-2.821-.937-5.344-2.82-6.944-5.592-1.681-2.912-2.094-5.858-1.584-8.538.573-3.018 2.304-5.691 4.655-7.597 2.346-1.901 5.313-3.043 8.387-2.982 2.62.051 5.31.983 7.754 3.04l.304.263 2.224 1.976-.6-2.914c-.545-2.647-.23-5.38.853-7.8a12.583 12.583 0 015.22-5.777zm.133 26.203a12.342 12.342 0 00-5.76 7.466 12.174 12.174 0 001.202 9.314 12.174 12.174 0 007.466 5.698c3.04.803 6.395.448 9.346-1.255a12.33 12.33 0 005.754-7.464 12.177 12.177 0 00-1.203-9.313 12.177 12.177 0 00-7.463-5.698 12.33 12.33 0 00-9.342 1.252z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpring);
export default __webpack_public_path__ + "static/media/spring.0038f7d6.svg";
export { ForwardRef as ReactComponent };